// extracted by mini-css-extract-plugin
export default {"outstandingBalance":"OutstandingBalance_outstandingBalance","title":"OutstandingBalance_title","money":"OutstandingBalance_money"};